var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#FF6B00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 20V16.5",
    stroke: "#FF6B00",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14C20.8807 14 22 12.8807 22 11.5C22 10.1193 20.8807 9 19.5 9C18.1193 9 17 10.1193 17 11.5C17 12.8807 18.1193 14 19.5 14Z",
    stroke: "#FF6B00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22.5V19.5145C13.5001 19.3553 13.5381 19.1985 13.611 19.057C13.6839 18.9155 13.7895 18.7935 13.919 18.701L17 16.5H22L24.8845 18.5605C25.0617 18.6871 25.2754 18.7523 25.493 18.7464C25.7107 18.7404 25.9205 18.6636 26.0905 18.5275L28 17",
    stroke: "#FF6B00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4445 26.5L23.1165 23.55C23.1015 23.4149 23.0591 23.2844 22.992 23.1662C22.9248 23.0481 22.8343 22.9449 22.7259 22.8629C22.6175 22.7809 22.4936 22.7219 22.3617 22.6894C22.2297 22.657 22.0925 22.6517 21.9585 22.674L18.7465 23.2095C18.5316 23.2453 18.3115 23.2339 18.1014 23.176C17.8914 23.1181 17.6965 23.0151 17.5302 22.8743C17.364 22.7334 17.2305 22.558 17.1389 22.3603C17.0473 22.1626 16.9999 21.9474 17 21.7295V16.5",
    stroke: "#FF6B00",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 31H20.5L21 28.5H26L26.5 31Z",
    stroke: "#FF6B00",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26L17.553 27.7885C17.518 27.928 17.4534 28.0583 17.3635 28.1705L15.5 30.5",
    stroke: "#FF6B00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
};
export default __webpack_public_path__ + "static/media/ic_exercise.b3e17854.svg";
export { SvgComponent as ReactComponent };